import axios from 'axios';

export const fetchLectures = async (category = '') => {
  try {
    // Add category as query param if provided
    const url = `${process.env.REACT_APP_APIURL}fetch-lectures`;
    const response = await axios.get(url, {
      params: { category }
    });
    return response.data;
  } catch (error) {
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || "Error fetching lectures",
    };
  } 
};

export const fetchCourseCategory = async () => {
  try {
    // console.log(process.env.REACT_APP_API_URL);
    const response = await axios.get(`${process.env.REACT_APP_APIURL}fetch-course-category`);
    return response.data;
  } catch (error) {
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || "Error fetching lectures",
    };
  }
};

//To save data to db when signup
export const saveCandidate = async (candidateData) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_APIURL}save-candidate`, candidateData);
    return response.data;
  } catch (error) {
    console.error("SaveCandidate error:", error.response?.data || error.message);
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || error.message || "Error saving candidate",
    };
  }
};

//User Upload Assignments 
export const saveAssignment = async (assignmentData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_APIURL}upload-assignment`, 
      assignmentData,
      { 
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    return response.data;
  } catch (error) {
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || "Error uploading assignment",
    };
  }
};
 
//Not used this api
export const fetchCandidate = async () => {
  const userId = localStorage.getItem('loggedInUserId');
  if (!userId) return { status: 401, message: "User UID not found" };
  const url = `${process.env.REACT_APP_APIURL}fetch-candidate`;

  try {
    const res = await axios.get(url, { params: { uid: userId } });
    return res.data;
  } catch (err) {
    console.error("API call failed:", err);
    return { status: err.response?.status || 500, message: err.message };
  }
};

//fetching assignment for profile page 
export const fetchAssignment = async () => {
  const userId = localStorage.getItem('loggedInUserId');
  if (!userId) return { status: 401, message: "User UID not found" };
  const url = `${process.env.REACT_APP_APIURL}fetch-assignment`;

  try {
    const res = await axios.get(url, { params: { uid: userId } });
    return res.data;
  } catch (err) {
    console.error("API call failed:", err);
    return { status: err.response?.status || 500, message: err.message };
  }
};

//delete assignment for profile page 
export const deleteAssignment = async (assignmentId) => {
  const userId = localStorage.getItem('loggedInUserId');
  if (!userId) return { status: 401, message: "User UID not found" };
  if (!assignmentId) return { status: 400, message: "Assignment ID not provided" };

  const url = `${process.env.REACT_APP_APIURL}delete-assignment`;

  try {
    const res = await axios.get(url, {
      params: { uid: userId, id: assignmentId },  // Send both uid and id as query params
    });
    return res.data;
  } catch (err) {
    console.error("API call failed:", err);
    return {
      status: false,
      message: err.response?.data?.message || err.message || "Unknown error occurred"
    };
  }
};

//used to fetch access in video dashboard
export const fetchAccess = async () => {
  const userId = localStorage.getItem('loggedInUserId');
  if (!userId) return { status: 401, message: "User UID not found" };
  const url = `${process.env.REACT_APP_APIURL}fetch-access`;

  try {
    const res = await axios.get(url, { params: { uid: userId } });
    return res.data;
  } catch (err) {
    console.error("API call failed:", err);
    return { status: err.response?.status || 500, message: err.message };
  }
};

// check user isLoggedIn status
export const checkLoginStatus = async (email) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_APIURL}check-login-status`, {
      email,
    });
    return response.data; // Expected to be { isLoggedIn: 1 } or { isLoggedIn: 0 }
  } catch (error) {
    console.error('Error checking login status:', error);
    return { isLoggedIn: 0, error: true };
  }
};


// update user isLoggedIn status
export const updateisLoginStatus = async (uid, isLoggedIn) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_APIURL}update-login-status`, {
      uid,
      isLoggedIn,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user status:', error);
    throw new Error('Failed to update user status');
  }
};
